//注册全局方法
import { ElMessage } from 'element-plus'

export function message(text,type){
  let types = 'success'
  if(type == 1){
    types = "warning"
  }else if(type == 2){
    ElMessage.error(text)
    return
  }
  ElMessage({
    message: text,
    type: types,
  })
};

export function copy(obj){
  if(!obj){
    return
  }
  var newobj = obj.constructor === Array ? [] : {};
  if(typeof obj !== 'object'){
    return
  }
  for(var i in obj){
    newobj[i] = typeof obj[i] === 'object' ? this.$copy(obj[i]) : obj[i];
  }
  return newobj
};

export function fplx(code){
  if(code == '004'){
    return "增值税专用发票"
  }else if(code == '007'){
    return "增值税普通发票"
  }else if(code == '025'){
    return "卷式发票"
  }else if(code == '026'){
    return "电子普通发票"
  }else if(code == '005'){
    return "机动车发票"
  }else if(code == '006'){
    return "二手车销售统一发票"
  }else if(code == '028'){
    return "增值税电子专用发票"
  }
}

// export default{
//   install (Vue, options) {
//     Vue.prototype.$qzfMessage = function(){

//     }
//   }
// }



//原型链上增加方法
// String.prototype.moneyFilter = function(){
//   if(this.indexOf('(') > -1){
//     let amount = this.replace("(", "").replace(")","")
//     return Number((-amount.replace(/,/g, "").replace("¥", "").replace("å", "").replace("元", "").replace("￥", "")  * 1).toFixed(2))
//   }else{
//     return Number((this.replace(/,/g, "").replace("¥", "").replace("å", "").replace("元", "").replace("￥", "")  * 1).toFixed(2))
//   }
// }